import(/* webpackMode: "eager" */ "/vercel/path0/src/app/activations/page.tsx");
